export const isPdf = (fileName: string): boolean =>
  fileName.toLowerCase().includes(".pdf");

export const isExcel = (fileName: string): boolean =>
  fileName.toLowerCase().includes(".xls") ||
  fileName.toLowerCase().includes(".csv");

export const removeFullUrl = (name: string): string => {
  let displayName = name.includes("digitaloceanspaces.com/")
    ? name.substring(
        name.indexOf("digitaloceanspaces.com/") +
          "digitaloceanspaces.com/".length,
      )
    : name;

  // Presigned URLs carry a query string — never part of the display name
  displayName = displayName.split("?")[0];

  // Remove pattern: -[12 alphanumeric chars].
  displayName = displayName.replace(/-[a-z0-9]{12}\./g, ".");

  return displayName;
};

export const getFileName = (url: string) => url.split(".com/")[1];

/**
 *
 * @param input
 * @returns [fileNameWithoutExtension, extension]
 */
export const splitFileName = (input?: string): [string, string] => {
  if (!input) {
    return ["", ""];
  }
  const lastDotIndex = input.lastIndexOf(".");

  if (lastDotIndex === -1) {
    // No dot found in string, return whole string as first part and empty string as second
    return [input, ""];
  }

  const firstPart = input.substring(0, lastDotIndex);
  const secondPart = input.substring(lastDotIndex + 1);

  return [firstPart, secondPart];
};

interface GetFileNameInput {
  url: string;
  name: string;
  nameWithoutExtension?: string;
  extension?: string;
}
export const getFileNameNew = ({
  name,
  nameWithoutExtension,
  extension,
  url,
}: GetFileNameInput) => {
  if (!nameWithoutExtension) {
    return name;
  }
  if (!extension) {
    return nameWithoutExtension;
  }

  return `${nameWithoutExtension}.${extension}`;
};
